/**
 * Created by hp on 2017/7/25.
 */
const defaults = {
    // 当获得一张优惠券时，得到code，ReceiveCoupon会展示出来
    code: null,
    scope: null,
    target: null,
    // 当前页面有可用优惠券
    availableCoupon: null
};

export default (state=defaults, action) => {
    switch (action.type) {
        case 'COUPON_RECEIVE':
            return {...state, 
                code: action.payload.code, 
                scope: action.payload.scope, 
                target: action.payload.target,
                liveroom: action.payload.liveroom,
            };
        case 'COUPON_SET_AVAILABLE':
            return {...state, availableCoupon: action.payload.coupon};
        case 'PAGE_INIT':
            return {...state, ...defaults}
        default:
            return state;
    }
}




// WEBPACK FOOTER //
// ./src/reducers/coupon.js